export default __webpack_public_path__ + "static/media/material-symbols_menu.b34e2a88.svg";